import type { EntryPoint } from '#packages/apilib';
import {
  EditorAPIKey,
  BiApiKey,
  SectionsMigrationApiKey,
} from '#packages/apis';
import { createCopyPasteApi } from './copyPasteWrapper';
import { CopyPasteApiKey } from './publicApiKey';

export const CopyPasteEntrypoint: EntryPoint = {
  name: 'CopyPasteApi',
  declareAPIs: () => [CopyPasteApiKey],
  getDependencyAPIs: () => [EditorAPIKey, BiApiKey, SectionsMigrationApiKey],
  attach(shell) {
    shell.contributeAPI(CopyPasteApiKey, () => createCopyPasteApi(shell));
  },
};
